import { basicFilterInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';
import { configureLettersActionType } from '../actions/actionTypes';

export const REDUCER_NAME = 'ConfigureLettersFilterList';

const logCLListReq = (state, action) => ({
  ...state,
  listRequest: action.data ? action.data : state.listRequest,
  listRequestedOn: new Date(),
  loading: true,
});

const updateFilterConfig = (state, action) => {
  if (action.data.systemDefault) {
    return {
      ...state,
      systemDefaultFilter: action.data.systemDefault || null,
      userDefaultFilter: action.data.userDefault || null,
      selectedFilter: action.data.selectedItem || null,
    };
  }
  if (action.data.userDefault === null || action.data.userDefault) {
    return {
      ...state,
      selectedFilter: action.data.selectedItem || null,
      userDefaultFilter: action.data.userDefault,
    };
  }
  return {
    ...state,
    selectedFilter: action.data.selectedItem || null,
  };
};

const resetServerValue = (state, action) => ({
  ...state,
  serverRequestError: action.data && action.data.serverRequestError,
  loading: false,
});

const getEditItemDetailsResponse = (state, action) => ({
  ...state,
  getEditItemDetails: action.data,
});

const updateTableConfig = (state, action) => ({
  ...state,
  listColumnOrder: action.data ? action.data.detail.columnOrders : null,
  listParamOptions: action.data ? action.data.detail.parameters : null,
  listGroupBy: action.data ? action.data.detail.groupByParameters : null,
  listSortOptions: action.data ? action.data.detail.sortOptions : null,
  isDistinctActive: action.data ? action.data.detail.isDistinct : null,
  selectedFilter: action.data ? action.data : null,
});

function ConfigureLettersFilterListConfig(state = { ...basicFilterInitialState }, action = null) {
  switch (action.type) {
    // config list column configuration
    case configureLettersActionType.UPDATE_CL_FILTER_CONFIG:
      return updateFilterConfig(state, action);
    case configureLettersActionType.UPDATE_TABLE_CONFIGURATION:
      return updateTableConfig(state, action);
    case configureLettersActionType.REMOVE_CL_USER_DEFAULT_FILTER:
      return {
        ...state,
        userDefaultFilter: null,
      };
    default:
      return null;
  }
}

function ConfigureLettersFilterListREQRES(state = { ...basicFilterInitialState }, action = null) {
  switch (action.type) {
    // log request
    case configureLettersActionType.LOG_CL_LIST_REQUEST:
      return logCLListReq(state, action);
    // log error
    case configureLettersActionType.GET_CL_LIST_ERROR:
      return {
        ...state,
        listRequestError: action.data,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    // store response
    case configureLettersActionType.GET_CL_LIST_RESPONSE:
      return {
        ...state,
        listData: action.data,
        listRequestError: null,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    case configureLettersActionType.GET_CL_BY_ID_RESPONSE:
      return getEditItemDetailsResponse(state, action);
    case configureLettersActionType.RESET_CL_STORE:
      return {
        ...state,
        listData: null,
        listRequestError: null,
        listRequestProcessedOn: null,
        serverRequestError: null,
        loading: false,
      };
    case configureLettersActionType.RESET_CL_LOOKUPDATA:
      return {
        ...state,
        pageLevelLookupData: action.data,
      };
    case configureLettersActionType.RESET_SERVER_VALUE:
      return resetServerValue(state, action);
    case commonTypes.RESETSTORE:
      return basicFilterInitialState;
    default:
      return null;
  }
}
const ConfigureLettersFilterList = (state = { ...basicFilterInitialState }, action = null) => {
  const stateConfig = ConfigureLettersFilterListConfig(state, action);
  const stateReqRes = ConfigureLettersFilterListREQRES(state, action);
  if (stateConfig !== null) {
    return stateConfig;
  }
  if (stateReqRes !== null) {
    return stateReqRes;
  }
  return state;
};

export default ConfigureLettersFilterList;
